var _rect, _line, _line2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmoking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.88074,
    y: 16.2738,
    width: 16.9349,
    height: 3.70461,
    transform: "rotate(-44.2703 1.88074 16.2738)",
    stroke: "#D4BC87"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13.1131,
    y1: 5.2862,
    x2: 15.5285,
    y2: 7.69418,
    stroke: "#D4BC87"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.35297,
    y1: 12.9151,
    x2: 7.76831,
    y2: 15.3231,
    stroke: "#D4BC87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5504 4.36792C14.9046 3.03922 18.9737 1.70304 15.8408 0.532836",
    stroke: "#D4BC87",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoking);
export default __webpack_public_path__ + "static/media/smoking.bdc80221628b3d5259564256abeb9db8.svg";
export { ForwardRef as ReactComponent };